import axiosInstance from '../api/axiosInstance';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { toast } from 'sonner';

interface ErrorResponse {
  message: string;
  code?: string;
}

const toastStyle = {
  style: {
    padding: '1rem',
  },
};

export const apiService = {
  async request<T>(config: AxiosRequestConfig): Promise<T> {
    try {
      const response = await axiosInstance.api(config);
      return response.data;
    } catch (error) {
      this.handleError(error as AxiosError<ErrorResponse>);
      return Promise.reject(error);
    }
  },

  // 편의 메서드들
  async get<T>(url: string, params?: any, config?: any): Promise<T> {
    return this.request<T>({ method: 'GET', url, params, withCredentials: true, ...config });
  },  

  async post<T>(url: string, data?: any, config?: any): Promise<T> {
    return this.request<T>({ method: 'POST', url, data, withCredentials: true, ...config });
  },

  async put<T>(url: string, data: any, config?: any): Promise<T> {
    return this.request<T>({ method: 'PUT', url, data, withCredentials: true, ...config });
  },

  async delete<T>(url: string, data?: any, config?: any): Promise<T> {
    return this.request<T>({ method: 'DELETE', url, data, withCredentials: true, ...config });
  },

  async patch<T>(url: string, data?: any, config?: any): Promise<T> {
    return this.request<T>({ method: 'PATCH', url, data, withCredentials: true, ...config });
  },

  handleError(error: AxiosError<ErrorResponse>) {
    if (!error.response) {
      toast.error('네트워크 연결을 확인해주세요.', toastStyle);
      return;
    }

    const { status } = error.response;
    const message = error.response.data?.message;

    switch (status) {
      case 401:
        // 401은 이미 axiosInstance interceptor에서 처리됨
        toast.error(message || '로그인이 필요합니다.', toastStyle);
        break;
      case 403:
        toast.error(message || '접근 권한이 없습니다.', toastStyle);
        break;
      case 404:
        toast.error(message || '요청하신 리소스를 찾을 수 없습니다.', toastStyle);
        break;
      case 500:
        toast.error(message || '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.', toastStyle);
        break;
      default:
        toast.error(message || '알 수 없는 오류가 발생했습니다.', toastStyle);
    }
  }
};
